import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonRef", "options", "open", "onOpenChange", "dropdownStyles"];
import { useRef, useEffect } from 'react';
import { Dropdown } from './Dropdown';
import { Controllable } from '../Controllable/Controllable';
import { renderMenu } from './utils/renderMultiLevelMenu';
import { useIsKeyboardMode } from '../../../components/AppProvider/KeyboardModeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const UncontrolledMultiLevelDropdown = _ref => {
  let {
      buttonRef: externalButtonRef,
      options,
      open,
      onOpenChange,
      dropdownStyles
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const internalButtonRef = useRef(null);
  const buttonRef = externalButtonRef || internalButtonRef;
  const isKeyboardMode = useIsKeyboardMode();
  useEffect(() => {
    if (isKeyboardMode && open === false) {
      var _buttonRef$current;
      (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 || _buttonRef$current.focus();
    }
  }, [open, buttonRef, isKeyboardMode]);
  const renderMenuContent = () => renderMenu(options);
  return /*#__PURE__*/_jsx(Dropdown, Object.assign({}, rest, dropdownStyles, {
    "data-dropdown": true,
    animateOnToggle: false,
    buttonRef: buttonRef,
    Content: renderMenuContent,
    open: open,
    onOpenChange: onOpenChange
  }));
};
export const MultiLevelDropdown = Controllable(UncontrolledMultiLevelDropdown, ['open']);